import { Transform } from 'class-transformer';
import { DateTransform } from '@/utils/value-transformers/date.transform';

export default class AttendanceInsightModel {
  insight?: string | null;

  @Transform(DateTransform)
  dataGeracao?: Date | null;

  possuiNovasTranscricoes!: boolean;

  regenerado!: boolean;
}
